/* Erro: 4xx */

interface DetalheErroValidacao {
  loc: string[]
  msg: string
  type: string
}
export interface ValidacaoErro {
  detail: DetalheErroValidacao
}

export interface Erros {
  422: ValidacaoErro
}

/* Estados de requisição */

export const estados = { INICIAL: 0, PEDENTE: 1, SUCESSO: 2, ERRO: 3 } as const
export type Estados = typeof estados[keyof typeof estados]

/* status https */

export const STATUS = {
  malFormado: 400,
  naoPermitido: 403,
  naoAutorizado: 401,
  naoEncontrado: 404,
  conflito: 409,
  erroInterno: 500,
  indisponivel: 503,
  ok: 200,
} as const
type S = typeof STATUS
export type StatusHTTP = keyof S

export type ResultadoApiGET<T = any> = {
  resultados: T[]
  resultadosNessaPagina: number
  rotaPaginaAnterior: string
  rotaPrimeiraPagina: string
  rotaProximaPagina: string
  rotaUltimaPagina: string
  totalDeResultados: number
}
export type ResultadoAutenticacaoAPI = {
  token: string
  refreshToken: string
  tipo: string
}
export interface ParamsGeral {
  "por-pagina": string
  pagina: string
}

export interface CabecalhoBase {
  "X-Timesheet-Cache-Ignore": boolean,
}
